import { villageUpdateApi } from "../../api/village/villageUpdateApi"

type PayloadShape = Parameters<typeof villageUpdateApi>[0]

export async function villageUpdateService(payload: PayloadShape, token: string) {
	return await villageUpdateApi(payload, token)
}
